export default function IconChevronDown({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 24L6 14L7.4 12.6L16 21.2L24.6 12.6L26 14L16 24Z"
                fill="currentColor"
            />
        </svg>
    )
}
